import { ICON_TYPES } from '../constants';

export const RefreshIcon = (): JSX.Element => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8332 7C12.8377 8.35716 12.3705 9.67373 11.5115 10.7244C10.6525 11.7752 9.45505 12.4947 8.12405 12.76C6.79306 13.0252 5.41125 12.8197 4.21505 12.1786C3.01886 11.5375 2.08263 10.5006 1.56655 9.2454C1.05048 7.99018 0.986636 6.59463 1.38595 5.29754C1.78526 4.00044 2.62291 2.88242 3.75558 2.13477C4.88824 1.38711 6.24552 1.0563 7.59517 1.19893C8.94482 1.34157 10.203 1.94877 11.1543 2.91667H8.74983V4.08333H11.7499C12.0371 4.08302 12.3125 3.9688 12.5156 3.76572C12.7186 3.56263 12.8329 3.28728 12.8332 3.00008V0H11.6665V1.7955C10.4726 0.728847 8.94878 0.104272 7.3497 0.026159C5.75062 -0.0519541 4.17318 0.421127 2.881 1.36634C1.58882 2.31155 0.660197 3.67162 0.250328 5.21925C-0.15954 6.76688 -0.0258214 8.4083 0.629136 9.86918C1.28409 11.3301 2.42061 12.5219 3.84874 13.2455C5.27687 13.9691 6.91008 14.1806 8.47543 13.8447C10.0408 13.5088 11.4434 12.6458 12.4489 11.4C13.4544 10.1542 14.0019 8.60098 13.9998 7H12.8332Z"
        fill="#141414"
      />
    </svg>
  );
};

RefreshIcon.iconType = ICON_TYPES.REFRESH_ICON;
